import { useMemo, useState } from 'react'

import * as DeliveryHttp from '../../../../services/api/https/deliveries/delivery.http'
import {
  formatIsoDateToLocale,
  getPeriodoMesAtual,
  parseToMysqlFormat,
} from '../../../../services/util/date.service'
import { errorHandler } from '../../../../services/util/error.service'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  LOADING: 'Carregando dados',
}

const INITIAL_STATE = {
  palletArea: [],
  filteredPalletArea: [],
  periodo: getPeriodoMesAtual(),
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  selectedStatus: [],
}

export const STATUS_TAG_PALLET = [{ name: 'Tag Emitido' }, { name: 'Tag Não Emitido' }]

export default function useListagemTagPallet() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions

      async getPalletAreaTag(dataInicial, dataFinal, selectedTp) {
        await DeliveryHttp.getTagPallet(
          selectedTp,
          parseToMysqlFormat(dataInicial),
          parseToMysqlFormat(dataFinal),
        )
          .then(palletArea =>
            setState(prevState => ({
              ...prevState,
              palletArea: palletArea,
              filteredPalletArea: palletArea,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      //Events
      onInit(selectedTp) {
        if (selectedTp === 0) {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione o Operador Logístico desejado',
          }))
        } else {
          setState(prevState => ({
            ...prevState,
            loadingMessage: LOAD_MESSAGE.LOADING,
          }))
        }
      },

      onStatusChange(selected) {
        const values = selected.map(v => v.name)
        if (values.length === 0) {
          setState(prevState => ({
            ...prevState,
            selectedStatus: selected,
            filteredPalletArea: prevState.palletArea,
          }))
          return
        }
        setState(prevState => ({
          ...prevState,
          selectedStatus: selected,
          filteredPalletArea: prevState.palletArea.filter(pa => values.includes(pa.status)),
        }))
      },

      onBtnExportarExcelClick(palletArea) {
        const colunas = [
          [
            'código',
            'código picking',
            'descrição picking',
            'status',
            'qte. caixas',
            'empresa',
            'data criação',
          ],
        ]
        palletArea.forEach(p => {
          colunas.push([
            p.id,
            p.picking_id,
            p.picking_name,
            p.status,
            p.qte_caixas,
            p.company_name,
            formatIsoDateToLocale(p.created_at).toFormat('dd/MM/yy HH:mm:ss'),
          ])
        })

        gerarArquivoExcel('tag_pallet', colunas, 'tag_pallet.xlsx')
      },
    }
  }, [])

  return { state, localDispatch }
}
